/* @flow */

import xhr from './xhr-api-cs';
import applyLoading from './../../utils/apply-loading';

type Login = {
    apelido: string,
    nome: string,
    senha: string,
};

const pesquisar = (login: Login) => xhr.post('/logins', login, { headers : { Apelido: login.apelido }});

export default applyLoading(pesquisar);



// WEBPACK FOOTER //
// ./app/admin/login/pesquisar.js